
import './App.css';
import Home from './Pages/Home/Home/Home';
import {  Toaster } from 'react-hot-toast';

function App() {
  return (
    <div >
      <Home></Home>
      <Toaster></Toaster>
    </div>
  );
}

export default App;
